<template>
  <div class="instrument-management">
    <!-- 引入通用表格组件 -->
    <UniversalDataTable
      :columns="instrumentColumns"
      :form-fields="instrumentFormFields"
      :table-data="tableData"
      :pagination="pagination"
      :form-rules="instrumentFormRules"
      :uploadUrl="uploadImgUrl"
      :enable-selection="true"
      :enable-edit="true"
      :enable-delete="true"
      @search="handleSearch"
      @create="handleCreate"
      @update="handleUpdate"
      @delete="handleDelete"
      @pagination-change="handlePaginationChange"
      @selection-change="handleSelectionChange" />
  </div>
</template>

<script>
// 引入通用表格组件（确保路径正确）
import UniversalDataTable from '@/components/common/commonTable.vue';
import insturmentApi from '@/api/instrument.js';
import baseData from '@/api/base.js';
import {sliceImgUrl} from '@/utils/MyUtils.js'

export default {
  name: 'InstrumentManagement',
  components: {
    UniversalDataTable
  },
  data() {
    return {
      // 表格数据（实际从接口获取）
      tableData: [],
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      //搜索相关
      keyword:'',
      uploadImgUrl:baseData.IMG_BASE_URL
    };
  },
  computed: {
    baseUrl() {
      return `/instrument/page?pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}`
    },
    keywordUrl(keyword){
      return `/instrument/search/page?nameKeyword=${keyword}&pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}`
    },
    // 表格列配置（对应仪器数据字段）
    instrumentColumns() {
      return [
        {
          prop: 'instrumentNo',
          label: '仪器编号',
          width: 120,
          align: 'center'
        },
        {
          prop: 'platform',
          label: '仪器平台',
          width: 150
        },
        {
          prop: 'instrumentName',
          label: '仪器名称',
          width: 200
        },
        {
          prop: 'model',
          label: '仪器型号',
          width: 180
        },
        {
          prop: 'applicationScope',
          label: '应用范围',
          // 超长文本截取显示（hover 显示完整内容）
          formatter: (value) => {
            if (!value) return '';
            return value.length > 20 ? `${value.slice(0, 20)}...` : value;
          }
        },
        {
          prop: 'price',
          label: '收费价格',
          width: 150,
          align: 'center'
        },
        {
          prop: 'quantity',
          label: '仪器数量',
          width: 120,
          align: 'center'
        },
        {
          prop: 'contactPerson',
          label: '联系人',
          width: 120
        },
        {
          prop: 'contactInfo',
          label: '联系方式',
          width: 150
        },
        {
          prop: 'imageUrl',
          label: '仪器图片',
          type: 'image',  // 触发通用组件的图片特殊处理
          width: 120,
          align: 'center'
        }
      ];
    },

    // 表单字段配置（新增/编辑弹窗用）
    instrumentFormFields() {
      return [
        {
          prop: 'platform',
          label: '仪器平台',
          type: 'input',
          required: true,
          props: {
            placeholder: '请输入仪器平台'
          }
        },
        {
          prop: 'instrumentName',
          label: '仪器名称',
          type: 'input',
          required: true,
          props: {
            placeholder: '请输入仪器名称'
          }
        },
        {
          prop: 'model',
          label: '仪器型号',
          type: 'input',
          required: true,
          props: {
            placeholder: '请输入仪器型号'
          }
        },
        {
          prop: 'applicationScope',
          label: '应用范围',
          type: 'input',
          required: true,
          props: {
            type: 'textarea',  // 多行文本框（适配 text 类型字段）
            rows: 4,
            placeholder: '请输入应用范围'
          }
        },
        {
          prop: 'price',
          label: '收费价格',
          type: 'input',
          required: true,
          props: {
            placeholder: '请输入收费价格（如：100元/天 或 200元/次）'
          }
        },
        {
          prop: 'quantity',
          label: '仪器数量',
          type: 'input',
          required: true,
          props: {
            type: 'number',
            min: 1,
            placeholder: '请输入仪器数量'
          }
        },
        {
          prop: 'contactPerson',
          label: '联系人',
          type: 'input',
          required: true,
          props: {
            placeholder: '请输入联系人'
          }
        },
        {
          prop: 'contactInfo',
          label: '联系方式',
          type: 'input',
          required: true,
          props: {
            placeholder: '请输入联系方式（电话/微信等）'
          }
        },
        {
          prop: 'imageUrl',
          label: '仪器图片',
          type: 'image-upload',
          uploadUrl:baseData.IMG_BASE_URL,
          required: false,  // 图片非填
          limit:3,
          hint: '支持 JPG、PNG、WEBP 格式，大小不超过 2MB',
          props: {
            // 可额外配置上传参数（如 headers、data 等）
          }
        }
      ];
    },
    // 表单验证规则
    instrumentFormRules() {
      return {
        platform: [
          { required: true, message: '请输入仪器平台', trigger: 'blur' }
        ],
        instrumentName: [
          { required: true, message: '请输入仪器名称', trigger: 'blur' }
        ],
        model: [
          { required: true, message: '请输入仪器型号', trigger: 'blur' }
        ],
        applicationScope: [
          { required: true, message: '请输入应用范围', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入收费价格', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入仪器数量', trigger: 'blur' },
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactInfo: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]
      };
    }
  },
  mounted() {
    this.loadInstrumentList(this.baseUrl)
  },
  methods: {
    // ---------------------- 数据接口相关（实际对接后端）----------------------
    // 加载仪器列表数据（可传入搜索关键词和分页参数）
    async loadInstrumentList(url) {
      try {
        const response = await this.$http.get(url);
        this.pagination.total = response.data.total;
        this.tableData = response.data.records;
        //对表格数据中的tableData做处理,遍历每行，将imageUrl拆解为封面和所有图片url两部分，而且要附加上基础路径
        sliceImgUrl(this.tableData,'imageUrl')
        this.error = null;
      } catch (err) {
        this.error = '数据加载失败，请稍后重试';
        console.error('加载仪器数据出错:', err);
      }
    },

    // ---------------------- 通用表格回调函数 ----------------------
    // 搜索回调（关键词搜索）
    handleSearch(keyword) {
      console.log('搜索关键词：', keyword);
      this.keyword = keyword
      this.pagination.currentPage = 1;
      let url = `/instrument/search/page?nameKeyword=${keyword}&pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}`;
      this.loadInstrumentList(url)
    },

    // 新增数据回调
    async handleCreate(formData) {
      console.log('新增仪器数据：', formData);
      // 实际项目中调用新增接口，示例：
      try {
        // 调用接口，传递表单数据（自动转为 JSON）
        const res = await insturmentApi.create(formData);
        if (res.code == 200) {
          this.$message.success(res.msg || '新增成功');
          // 重新加载列表数据
          this.loadInstrumentList(this.baseUrl);
        }
      } catch (error) {
        this.$message.error('新增失败：' + (error.msg || '网络错误'));
      }
    },

    // 编辑数据回调
    async handleUpdate(formData) {
      try {
        // 确保携带主键 instrumentNo（后端需通过主键更新）
        if (!formData.instrumentNo) {
          this.$message.error('仪器编号不能为空');
          return;
        }
        const res = await insturmentApi.update(formData);
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.loadInstrumentList(this.baseUrl);
        }
      } catch (error) {
        this.$message.error('编辑失败：' + (error.msg || '网络错误'));
      }
    },

    // 删除数据回调
     async handleDelete(row) {
      console.log('删除仪器数据：', row.instrumentNo);
      try{
        const res = await insturmentApi.delete(row.instrumentNo);
        if(res.code===200){
          this.$message.success(res.msg);
          this.loadInstrumentList(this.baseUrl);

        }
      }
      catch(err){
        this.$message.error('删除失败'+(err.msg||'网络错误'))
      }
    },

    // 分页变化回调
    handlePaginationChange(pagination) {
      console.log('分页变化：', pagination);
      this.pagination = pagination;
      if(this.keyword!=''){
      this.loadInstrumentList(this.uploadUrl(this.keyword));
      }else{
        this.loadInstrumentList(this.baseUrl);
      }
    },

    // 选择行变化回调
    handleSelectionChange(selectedRows) {
      console.log('选中的仪器：', selectedRows);
      // 可用于批量操作（如批量删除、批量导出等）
    }
  },

};
</script>

<style scoped>
.instrument-management {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}
</style>